module.exports = __webpack_public_path__ + "img/case73.029c60cb.png";